import React from 'react';

const ProjectHighlights = () => {
  const projects = [
    {
      title: "Refinery SIS Upgrade – North America",
      client: "Major Oil & Gas Corporation",
      location: "Texas, USA",
      scope: "Complete safety instrumented system upgrade for a 250,000 bpd refinery",
      achievements: [
        "Zero safety incidents during implementation",
        "30% reduction in spurious trips",
        "Full IEC 61511 compliance achieved"
      ],
      icon: "fas fa-oil-can",
      color: "from-blue-600 to-blue-800"
    },
    {
      title: "Petrochemical Safety Assessment – Middle East",
      client: "National Petrochemical Company",
      location: "Saudi Arabia",
      scope: "Comprehensive safety lifecycle assessment for ethylene production facility",
      achievements: [
        "Identified 47 safety gaps",
        "Implemented risk reduction measures",
        "Achieved SIL 3 for critical functions"
      ],
      icon: "fas fa-flask",
      color: "from-purple-600 to-purple-800"
    },
    {
      title: "GTL Plant Lifecycle Migration – Central Asia",
      client: "International Energy Consortium",
      location: "Kazakhstan",
      scope: "Digital transformation of safety lifecycle management for gas-to-liquids facility",
      achievements: [
        "Migrated 2,000+ safety documents",
        "Implemented real-time monitoring",
        "85% reduction in audit preparation time"
      ],
      icon: "fas fa-industry",
      color: "from-green-600 to-green-800"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Project Highlights</h2>
          <p className="text-xl text-gray-600">Success stories from around the globe</p>
        </div>
        
        <div className="space-y-8">
          {projects.map((project, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="md:flex">
                <div className={`md:w-1/4 bg-gradient-to-br ${project.color} p-8 flex items-center justify-center`}>
                  <i className={`${project.icon} text-6xl text-white`}></i>
                </div>
                <div className="md:w-3/4 p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{project.title}</h3>
                  <div className="flex flex-wrap gap-4 mb-4">
                    <span className="text-gray-600">
                      <i className="fas fa-building mr-2"></i>{project.client}
                    </span>
                    <span className="text-gray-600">
                      <i className="fas fa-map-marker-alt mr-2"></i>{project.location}
                    </span>
                  </div>
                  <p className="text-gray-700 mb-4 font-medium">{project.scope}</p>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Key Achievements:</h4>
                    <ul className="space-y-1">
                      {project.achievements.map((achievement, idx) => (
                        <li key={idx} className="flex items-center text-gray-700">
                          <i className="fas fa-check-circle text-green-500 mr-2"></i>
                          <span>{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 relative">
          <img
            src="/assets/asset-23.jpg"
            alt="Facility exterior"
            className="w-full rounded-lg shadow-xl"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-white/60 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default ProjectHighlights;
